import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4a53a252&scoped=true"
import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/style.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@/assets/css/renew_reset.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/assets/css/renew_stylesheet.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "@/assets/css/renew_animation.css?vue&type=style&index=3&prod&lang=css&external"
import style4 from "@/assets/css/renew_tab.css?vue&type=style&index=4&prod&lang=css&external"
import style5 from "@/assets/css/renew_add.css?vue&type=style&index=5&prod&lang=css&external"
import style6 from "@/assets/css/renew2_style.css?vue&type=style&index=6&prod&lang=css&external"
import style7 from "./App.vue?vue&type=style&index=7&id=4a53a252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a53a252",
  null
  
)

export default component.exports